module.exports = __webpack_public_path__ + "img/disney-free-l.bc4d5fe6.png";